import { motion } from "framer-motion";

export default function HowWeWork() {
  return (
    <section className="w-full bg-gradient-to-br from-white via-gray-50 to-white px-4 md:px-12 py-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        {/* LEFT IMAGE */}
        <motion.div
          initial={{ opacity: 0, x: -70, rotate: -2 }}
          whileInView={{ opacity: 1, x: 0, rotate: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="relative flex justify-center"
        >
          {/* Accent background */}
          <div className="absolute -top-6 -left-6 w-[85%] h-[95%] rounded-3xl bg-yellow-400/20"></div>

          <img
            src="/images/6.jpeg"
            alt="Interior Design"
            className="relative z-10 w-[85%] h-[520px] object-cover rounded-3xl shadow-2xl"
          />

          {/* Projects badge */}
          <div className="absolute z-20 bottom-6 left-10 bg-white rounded-2xl px-7 py-5 shadow-xl">
            <h2 className="text-4xl font-extrabold text-yellow-500">379+</h2>
            <p className="text-xs font-bold tracking-widest text-gray-700">
              PROJECTS DONE
            </p>
          </div>
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: 70 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          {/* Label */}
          <p className="text-sm font-bold tracking-[0.25em] text-yellow-500 mb-4">
            HOW WE WORK
          </p>

          {/* Heading (same content) */}
          <h3 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-14">
            Sure we build impressive
          </h3>

          {/* Steps */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-14 gap-y-12">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 180 }}
                className="group flex gap-6"
              >
                {/* Number box */}
                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-yellow-400 flex items-center justify-center shadow-md group-hover:shadow-xl transition">
                  <span className="text-white text-lg font-extrabold">
                    0{i + 1}
                  </span>
                </div>

                {/* Text */}
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-yellow-500 transition">
                    {step.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

      </div>
    </section>
  );
}

const steps = [
  {
    title: "First Consultation",
    desc: "The process begins with an initial consultation where a representative from Inspired Interiors meets with the client to discuss their project requirements, goals, and vision.",
  },
  {
    title: "Evaluation of the Project",
    desc: "The design team measures, takes pictures, and gathers any pertinent floor plans or architectural drawings as part of a comprehensive.",
  },
  {
    title: "Development of Design Concepts",
    desc: "Using information gathered from the assessment and the client's preferences, Inspired Interiors develops a design concept.",
  },
  {
    title: "Presentation & Approval",
    desc: "Inspired Interiors uses visual aids including 3D renderings, sketches, and material samples to show the design concept and space plans to the customer.",
  },
];
